module.exports = apiConf;


//////////////////
// WEBPACK FOOTER
// external "apiConf"
// module id = iQ39
// module chunks = 1